import React, { useEffect, useState } from "react";
import {
    Container,
    Box,
    Typography,
    Button,
    Grid,
    Paper,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useNavigate } from "react-router-dom";


const Step2 = () => {
    const navigate = useNavigate();
    const [classes, setClasses] = useState([]);
    const [audio, setAudio] = useState(new Audio("/audio/wellcome.mp3"));

    // Simulating fetching data from database (Replace with API call)
    useEffect(() => {
        setClasses([
            { id: 1, class: "A" },
            { id: 2, class: "B" },
            { id: 3, class: "C" },
            { id: 4, class: "D" },
            { id: 5, class: "E" },
            { id: 6, class: "F" },
        ]);
    }, []);

    // Handle Audio Play/Pause
    const playAudio = () => {
        localStorage.setItem("audio", "Play");
        audio.play();
    };

    const pauseAudio = () => {
        localStorage.setItem("audio", "pause");
        audio.pause();
    };

    useEffect(() => {
        const interval = setInterval(() => {
            if (localStorage.getItem("audio") === "Play") {
                // playAudio();
            }
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundImage: `url(image/background.jpg)`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                p: 2,
            }}
        >
            <Container maxWidth="md">

                <Grid item xs={4}>
                    <Grid container justifyContent="space-between" alignItems="center">
                        {/* Left Image */}
                        <Grid item>
                            <img src="/image/Actify365.png" alt="Logo" width="200px" />
                        </Grid>

                        {/* Right Image */}
                        <Grid item>
                            <img src="/image/Actify365.png" alt="School Logo" width="200px" />
                        </Grid>
                    </Grid>
                </Grid>
                <Box sx={{

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height:"60vh",
                    flexDirection:"column",
                    p: 2,
                }}>




                    {classes.map((cls) => (
                        <Button
                            key={cls.id}
                            variant="contained"
                            color="primary"

                            sx={{ px: 4, backgroundColor:"#ff66a5", borderColor: "#fff", border:3, color: "#fff",width: "300px", py: 1, fontSize: "18px", marginBottom:1, borderRadius: 5 }}
                            onClick={() => navigate(`/step3?classid=${cls.id}`)}
                        >
                            Class {cls.class}
                        </Button>
                    ))}
                </Box>

            </Container>
        </Box>
    );
};

export default Step2;
